export const countDecimals = (number: number): number => {
  const s = number.toString();
  if (s.includes('e-')) {
    const [base, exponent] = s.split('e-');
    const decPart = base.includes('.') ? base.split('.')[1] : '';
    return parseInt(exponent, 10) + decPart.length;
  } else if (s.includes('.')) {
    return s.split('.')[1].length;
  } else {
    return 0;
  }
};
